<template>
    <div>
      <b-form-group
        id="input-group-1"
        label="Cliente:"
        label-for="input-1"
        
      >
        <b-form-input
          id="input-1"
          v-model="vendedor_data.cliente"
          name="cliente"
          v-validate="'required|min:2 '" 
          :state="$parent.validateState('cliente')"
          placeholder="Tu respuesta"
        ></b-form-input>

        <b-form-invalid-feedback>
          {{  errors.first('cliente') }}
        </b-form-invalid-feedback>

      </b-form-group>

      <b-form-group id="input-group-2" label="Producto:" label-for="input-2">
        <b-form-input
          id="input-2"
          v-model="vendedor_data.producto"
          name="producto"
          v-validate="'required|min:2'"
          :state="$parent.validateState('producto')"
          placeholder="Tu respuesta"
        ></b-form-input>
        <b-form-invalid-feedback>
          {{  errors.first('producto') }}
        </b-form-invalid-feedback>

      </b-form-group>

      <b-form-group id="input-group-3" label="Cantidad:" label-for="input-3">
        <b-form-input
          id="input-3"
          v-model="vendedor_data.cantidad"
          name= "cantidad"
          v-validate="'required'"
          :state="$parent.validateState('cantidad')"
          placeholder="Tu respuesta"
        ></b-form-input>
        <b-form-invalid-feedback>
          {{  errors.first('cantidad') }}
        </b-form-invalid-feedback>
      </b-form-group>

      <b-form-group id="input-group-4" label="Trabajo a realizar">
          <b-form-radio-group id="radio-group-1" v-model="vendedor_data.trabajo" name="radio-sub-component" stacked v-validate="'required'" :state="$parent.validateState('radio-sub-component')" >
             <b-form-radio value="Check List">Check List</b-form-radio>
             <b-form-radio value="Descargar Archivos">Descargar Archivos</b-form-radio>
             <b-form-radio value="Dummie">Dummie</b-form-radio>
             <b-form-radio value="Prueba de color">Prueba de color</b-form-radio>
             <b-form-radio value="Ficha Técnica">Ficha Técnica</b-form-radio>
             <b-form-radio value="PC Plano de costeo">PC Plano de costeo</b-form-radio>
             <b-form-radio value="Plano al 100%">Plano al 100%</b-form-radio>
             <b-form-radio value="PLC Planilla de costeo">PLC Planilla de costeo</b-form-radio>
             <b-form-radio value="PLF Planilla de formación">PLF Planilla de formación</b-form-radio>
             <b-form-radio value="Plano Mecánico">Plano Mecánico</b-form-radio>
             <b-form-radio value="PP propuesta de prensa">PP propuesta de prensa</b-form-radio>
             <b-form-radio value="Print Card">Print Card</b-form-radio>
             <b-form-radio value="Otro">Otro</b-form-radio>
         </b-form-radio-group> 
          <b-form-invalid-feedback>
            {{errors.first('radio-sub-component')}}
          </b-form-invalid-feedback>
          <b-form-input
          id="input-5"
          v-model="vendedor_data.otro"
          placeholder="Tu respuesta"
        ></b-form-input>  
        
        </b-form-group>

        <b-form-group id="input-group-5" label="Fecha requerida:" label-for="input-5">
          <b-form-datepicker 
            id="datepicker-sm" 
            size="sm" 
            local="en" 
            class="mb-2" 
            v-model="vendedor_data.fecha" 
            name="fecha"
            v-validate="'required'" 
            :state="$parent.validateState('fecha')" 
            >
          </b-form-datepicker> 
          <b-form-invalid-feedback>
            {{errors.first('fecha')}}
          </b-form-invalid-feedback>
        </b-form-group>

        <b-form-group id="input-group-6" label="Hora requerida:" label-for="input-6">
            <b-form-timepicker 
              v-model="vendedor_data.hora" 
              locale="en"
              name="hora"
              v-validate="'required'"
              :state="$parent.validateState('hora')"              
            >
            </b-form-timepicker>
            <b-form-invalid-feedback>
              {{errors.first('hora')}}
            </b-form-invalid-feedback>
        </b-form-group>
        <!--
        <b-form-group id="input-group-7" label="Quien solicita:" label-for="input-7">
          <b-form-select 
            v-model="vendedor_data.solicitante" 
            :options="solicitantes" 
            size="sm"
            name="solicitante"
            v-validate="'required'"
            :state="$parent.validateState('solicitante')"
          ></b-form-select>
          <b-form-invalid-feedback>
              {{errors.first('solicitante')}}
          </b-form-invalid-feedback>
        </b-form-group>
        -->
      <b-form-group id="input-group-8" label="Link de archivo:" v-for="(url,k) in vendedor_data.urls" :key="k" >
        <b-input-group>
          <b-form-input

            v-model="url.value"
           
          >

          </b-form-input>
          <b-input-group-append>
             
            
            <span v-show="k || ( !k && vendedor_data.urls.length > 1)" class="input-group-text"><i class="fa fa-minus-circle" @click="remove(k)" ></i></span>
            <span  v-show="k == vendedor_data.urls.length-1" class="input-group-text"><i class="fa fa-plus-circle" @click="add(k)"></i></span>   
          </b-input-group-append>
        </b-input-group>
      </b-form-group> 

      <b-form-group id="input-group-9" label="Observaciones:" label-for="input-9">
        <b-form-input
          id="input-9"
          v-model="vendedor_data.observaciones"
          placeholder="Tu observación"
        ></b-form-input>
      </b-form-group>
     
    </div>
</template>

<script>
    export default {
      inject:['$validator'],//para que el padre inyecte el validador a este componente hijo.
      props:{
        vendedor_data:{
          type: Object,
          required:true
        }
      },
      data: function(){
        return{
          inputs: [
            {
               value: ''
            }
          ]

        }
      },
      mounted(){
        this.vendedor_data.status = 'Abierta'
      },
      methods: {
        add(index) {
           this.vendedor_data.urls.push({ value: '' })
        },
        remove(index) {
            this.vendedor_data.urls.splice(index, 1)
        }
    }

        
    }
</script>

<style lang="scss" scoped>

</style>